import * as React from 'react';
import { Input, Select, Typography } from '@duxton-web/ui';

import { ControlledInputPropsBase } from '../../common/InputControlProps';
import { getTenant } from '../Tenants';
import {
  getAppOptionsMap,
  osOptionsMap,
  parseAppVersion,
} from './appVersionUtils';

const { Option } = Select;

interface AppVersionFieldsetProps extends ControlledInputPropsBase<string> {
  getPopupContainer?: (triggerNode: HTMLElement) => HTMLElement;
}

const AppVersionFieldset: React.FC<AppVersionFieldsetProps> =
  function AppVersionFieldset({ value, onChange, getPopupContainer }) {
    const [app, os, version] = parseAppVersion(value!);
    const appOptionsMap = getAppOptionsMap(getTenant());
    return (
      <div style={{ display: 'flex' }}>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <Typography.Text strong style={{ paddingBottom: 4 }}>
            App
          </Typography.Text>
          <Select
            value={app || undefined}
            onChange={(val) => onChange(`${val}-${os}-${version}`)}
            placeholder="Select"
            style={{ width: 200 }}
            getPopupContainer={getPopupContainer}
          >
            {Object.keys(appOptionsMap).map((a) => (
              <Option key={a} value={a}>
                {appOptionsMap[a]}
              </Option>
            ))}
          </Select>
        </div>
        <div style={{ padding: '0 4px' }} />
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <Typography.Text strong style={{ paddingBottom: 4 }}>
            OS
          </Typography.Text>
          <Select
            value={os || undefined}
            onChange={(val) => onChange(`${app}-${val}-${version}`)}
            placeholder="Select"
            style={{ width: 200 }}
            getPopupContainer={getPopupContainer}
          >
            {Object.keys(osOptionsMap).map((o) => (
              <Option key={o} value={o}>
                {osOptionsMap[o]}
              </Option>
            ))}
          </Select>
        </div>
        <div style={{ padding: '0 4px' }} />
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <Typography.Text strong style={{ paddingBottom: 4 }}>
            Version
          </Typography.Text>
          <Input
            data-testid="appVersionInput"
            value={version}
            onChange={(event) => onChange(`${app}-${os}-${event.target.value}`)}
            style={{ width: 200 }}
            placeholder="Enter"
          />
        </div>
      </div>
    );
  };

export default AppVersionFieldset;
